<div class="modal-header">
  <h4 class="modal-title">Clone Planogram</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <p class="text-muted">Cloning: <strong>{{ planogram.storeName }} - {{ planogram.merchName }}</strong></p>
  
  <form [formGroup]="cloneForm">
    <!-- Store Selection -->
    <div class="mb-3">
      <label class="form-label text-dark">Store <span class="text-danger">*</span></label>
      <input type="text" class="form-control"
             [ngbTypeahead]="searchStores"
             [inputFormatter]="storeFormatter"
             [resultFormatter]="storeFormatter"
             formControlName="store"
             placeholder="Search for a store..." />
    </div>

    <!-- Merchandise Selection -->
    <div class="mb-3">
      <label class="form-label text-dark">Merchandise Category (Optional)</label>
      <input type="text" class="form-control"
             [ngbTypeahead]="searchMerch"
             [inputFormatter]="merchFormatter"
             [resultFormatter]="merchFormatter"
             formControlName="merch"
             [editable]="false"
             [disabled]="!cloneForm.get('store')?.value"
             placeholder="{{ !cloneForm.get('store')?.value ? 'Select a store first...' : 'Search for merchandise...' }}" />
    </div>

    <!-- Folder Selection -->
    <div class="mb-3">
      <label class="form-label text-dark">Folder</label>
      <select class="form-select" formControlName="folderId">
        <option value="">-- Default Folder --</option>
        @for (f of flatFolders; track f.id) {
          <option [value]="f.id">{{ f.name }}</option>
        }
      </select>
    </div>

    <!-- Optional New Name -->
    <div class="mb-3">
      <div class="d-flex justify-content-between">
        <label class="form-label text-dark">Name (Optional)</label>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="autoNameCheck" formControlName="autoName">
          <label class="form-check-label text-muted small" for="autoNameCheck">
            Standard Format
          </label>
        </div>
      </div>
      <input type="text" class="form-control" formControlName="name" [placeholder]="latestState?.name" />
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">Cancel</button>
  <button type="button" class="btn btn-primary" [disabled]="cloneForm.invalid" (click)="submit()">
    Clone Planogram
  </button>
</div>